/* Drawer Toggles */
function toggleMobileDrawer(active) {
  const d = document.getElementById('mobileDrawer');
  const o = document.getElementById('mobileOverlay');
  if (!d || !o) return;

  if (active) {
    d.classList.add('active');
    o.classList.add('active');
    document.body.style.overflow = 'hidden';
  } else {
    d.classList.remove('active');
    o.classList.remove('active');
    document.body.style.overflow = '';
  }
}

function toggleSideDrawer(active) {
  const d = document.getElementById('mpSideDrawer');
  const o = document.getElementById('mpSideOverlay');
  if (!d || !o) return;

  if (active) {
    d.classList.add('is-open');
    o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  } else {
    d.classList.remove('is-open');
    o.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

/* Cart UI Rendering */
function renderCartItems(cart) {
  const container = document.getElementById('mp-cart-item-container');
  const subtotal = document.getElementById('mp-cart-total-price');
  const footerContent = document.getElementById('mp-cart-footer-content');
  const countCircle = document.querySelector('#mpDrawerTitle .mp-cart-count-circle');

  if (!container) return;

  // 1. HANDLE EMPTY STATE
  if (cart.item_count === 0) {
    container.innerHTML = '<p style="text-align:center; padding-top:40px;">Your cart is currently empty.</p>';
    
    // Hide financial info and checkout button
    if (footerContent) footerContent.style.display = 'none';
    
    // Update count circle in title to 0
    if (countCircle) countCircle.textContent = '0';
    
    // Update subtotal if it exists
    if (subtotal) subtotal.textContent = '$0.00';
    
    return;
  }

  // 2. HANDLE POPULATED STATE
  // Ensure footer is visible if items exist
  if (footerContent) footerContent.style.display = 'block';

  // Map items to HTML
  let html = cart.items.map(item => {
    const itemImg = item.image ? item.image : '';
    return `
      <div class="mp-cart-item" style="display:flex; gap:15px; padding:15px 0; border-bottom:1px solid #eee; align-items: center;">
        <div style="width:70px; flex-shrink:0;">
          <img src="${itemImg}" alt="${item.product_title}" style="width:100%; height:auto; display:block;">
        </div>
        <div style="flex:1;">
          <div style="font-weight:700; font-size:14px; margin-bottom:4px; line-height:1.4;">
            ${item.product_title}
          </div>
          <div style="font-size:13px; color:#666;">
            <span style="font-weight:500; color:#000;">Qty: ${item.quantity}</span>
            <span style="margin: 0 8px; color:#ccc;">|</span>
            <span>$${(item.final_line_price / 100).toFixed(2)}</span>
          </div>
        </div>
        <button type="button" class="mp-cart-remove-link" aria-label="Remove ${item.product_title}" onclick="removeCartItem('${item.key}')">
          <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g class="remove-icon-top">
              <path d="M2 4H14V3C14 2.44772 13.5523 2 13 2H3C2.44772 2 2 2.44772 2 3V4Z" stroke="currentColor" stroke-width="1.2"/>
              <path d="M6 2V1H10V2" stroke="currentColor" stroke-width="1.2"/>
            </g>
            <g class="remove-icon-bottom">
              <path d="M3 4H13V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V4Z" stroke="currentColor" stroke-width="1.2"/>
              <path d="M6 7V12" stroke="currentColor" stroke-width="1.2"/>
              <path d="M10 7V12" stroke="currentColor" stroke-width="1.2"/>
            </g>
          </svg>
        </button>
      </div>`;
  }).join('');

  // Update the container with new item list
  container.innerHTML = html;

  // Update Subtotal Price
  if (subtotal) {
    subtotal.textContent = '$' + (cart.total_price / 100).toFixed(2);
  }

  // Update Item Count Circle (Targeting specific nested element within the title link)
  if (countCircle) {
    countCircle.textContent = cart.item_count;
  }
}

/* Header Cart Count Update */
function updateKFHeaderCart(newCount, shouldFlash) {
  const dCount = document.getElementById('kf-cart-count-desktop');
  const mCount = document.getElementById('kf-cart-count-mobile');
  if (dCount) dCount.textContent = newCount;
  if (mCount) mCount.textContent = newCount;

  if (shouldFlash) {
    document.querySelectorAll('.kf-cart-link-desktop, .kf-cart-link-mobile').forEach(l => {
      l.classList.add('kf-cart-alert');
      setTimeout(() => l.classList.remove('kf-cart-alert'), 10000);
    });
  }
}

/* API Calls */
function removeCartItem(itemKey) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: 0 })
  })
  .then(response => response.json())
  .then(cart => {
    renderCartItems(cart);
    updateKFHeaderCart(cart.item_count, false);
  })
  .catch(error => console.error('Error:', error));
}

/* Main Initialization */
document.addEventListener('DOMContentLoaded', function() {
  const settings = window.kfHeaderSettings || {};

  // Event Delegation for clicks
document.addEventListener('click', function(e) {
  const trigger = e.target.closest('.mp-drawer-trigger');
  
  // Updated: Look for either the chevron OR the parent text link
  const toggle = e.target.closest('.drawer-toggle') || e.target.closest('.drawer-menu-parent');

  // Drawer Trigger Logic (Cart/Search)
  if (trigger && settings.useDrawer) {
    if (settings.isCartPage && trigger.dataset.mode === 'cart') {
      return; 
    }
    e.preventDefault();
    openSideDrawer(trigger.dataset.mode);
  }
  
  // Sub-menu Toggle Logic
  if (toggle) {
    // If it's the <a> link, prevent the "#" jump
    if (toggle.classList.contains('drawer-menu-parent')) {
      e.preventDefault();
    }

    const wrapper = toggle.closest('.nav-item-wrapper');
    const chevron = wrapper.querySelector('.drawer-toggle');
    const subMenu = wrapper.nextElementSibling;

    // Toggle the 'active' class on the chevron for rotation
    if (chevron) {
      chevron.classList.toggle('active');
    }

    // Toggle the 'open' class on the sub-menu 
    if (subMenu) {
      subMenu.classList.toggle('open');
    }
  }
});

  // Intercept Fetch calls for Add to Cart
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(response => {
      if (response.url.includes('/cart/add') || response.url.includes('/cart/change')) {
        setTimeout(() => {
          fetch('/cart.js').then(r => r.json()).then(cart => {
            updateKFHeaderCart(cart.item_count, true);
            if (settings.useDrawer && !settings.isCartPage) renderCartItems(cart);
            if (settings.useDrawer && !settings.isCartPage && response.url.includes('/cart/add')) openSideDrawer('cart');
          });
        }, 1000);
      }
      return response;
    });
  };
});

function changeCardQty(btn, amt) {
  const input = btn.closest('.kf-qty-selector').querySelector('.mp-card-qty-input');
  let val = parseInt(input.value) + amt;
  input.value = val < 1 ? 1 : val;
}

async function addCardToCart(btn, variantId) {
  const qtyInput = btn.closest('.mp-card-purchase').querySelector('.mp-card-qty-input');
  const qty = qtyInput.value;
  const originalText = btn.innerText;

  // 1. THE TRULY OPTIMISTIC TRIGGER
  // We fire this BEFORE the fetch even starts.
  // We wrap it in a 0ms timeout to ensure it fires on its own thread instantly.
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent('cart-updated'));
  }, 0);

  // 2. UI UPDATE
  btn.innerText = "Adding...";
  btn.disabled = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    });

    if (response.ok) {
      // 3. SECONDARY DRAWER TRIGGER (In case the first one was too early)
      window.dispatchEvent(new CustomEvent('cart-updated'));

      btn.innerText = "Added!";
      
      setTimeout(() => {
        btn.innerText = originalText;
        btn.disabled = false;
      }, 2000);
    } else {
      throw new Error('Response not ok');
    }
  } catch (e) {
    btn.innerText = "Error";
    setTimeout(() => {
      btn.innerText = originalText;
      btn.disabled = false;
    }, 2000);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const gridContainer = document.getElementById('mpProductGrid');
  const viewButtons = document.querySelectorAll('.mp-view-btn');

  if (gridContainer && viewButtons.length > 0) {
    viewButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const val = this.getAttribute('data-val');
        const isMobile = window.innerWidth < 768;

        // Update Active Button
        viewButtons.forEach(b => {
          if ((isMobile && b.classList.contains('mp-hide-desktop')) || (!isMobile && !b.classList.contains('mp-hide-desktop'))) {
             b.classList.remove('active');
          }
        });
        this.classList.add('active');

        // Swap Classes
        if (isMobile) {
          gridContainer.classList.remove('mp-mobile-grid-1', 'mp-mobile-grid-2');
          gridContainer.classList.add('mp-mobile-grid-' + val);
        } else {
          gridContainer.classList.remove('mp-grid-4', 'mp-grid-6');
          gridContainer.classList.add('mp-grid-' + val);
        }
      });
    });
  }
});